import {Component, EventEmitter, Output} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Payment} from "../payment";
import {PaymentService} from "../payment-service.service";

@Component({
  selector: 'app-invoice-form',
  templateUrl: './payment-form.component.html',
  styleUrls: ['./payment-form.component.css']
})
export class PaymentFormComponent {

  payment: Payment;
  customerId: string;
  invoiceId: string;
  id: string;
  action: string;
  myError: string;
  stop: string;

  @Output() refresh = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService) {
    this.customerId = route.snapshot.params['customerId'];
    this.invoiceId = route.snapshot.params['invoiceId'];
    this.action = route.snapshot.params['action'];
    this.id = route.snapshot.params['id'];
    this.myError = "";
    this.stop = "";
    if (this.action.localeCompare("add") == 0) {
      this.payment = new Payment();
      this.payment.invoiceId = route.snapshot.params['invoiceId'];
    }
  }

  ngOnInit() {
    if (this.action.localeCompare("edit") == 0) {
      this.paymentService.findById(this.id).subscribe(data => this.payment = data, error => {this.stop = "1"; this.myError = "Payment not found"});
    }
  }

  onSubmit() {
    if (this.action.localeCompare("add") == 0) {
      this.paymentService.save(this.payment, this).subscribe(result => this.gotoPaymentList(), error => this.refresh.emit());
    } else {
      this.paymentService.update(this.payment, this).subscribe(result => this.gotoPaymentList(), error => this.refresh.emit());
    }
  }

  gotoPaymentList() {
    this.router.navigate(['/payments/show/' + this.customerId + "/" + this.invoiceId + "/0"]);
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-form/payment-form.component.ts